module.exports = __webpack_public_path__ + "static/media/language3.0cbe2cd7.png";